import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "sidebar-subtitle" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

import * as utils from '@services/utils/common';


export default /*@__PURE__*/_defineComponent({
  __name: 'SidebarSubtitle',
  props: {
    size: { default: 0 },
    mtime: { default: 0 }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.size)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(utils.humanFileSize(__props.size)), 1))
      : _createCommentVNode("", true),
    (__props.mtime)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(utils.getFromNowStr(new Date(__props.mtime * 1000))), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})